var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4 bg-blue-100 border border-blue-200"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }